const KIBERNETES_VERSION = '2.0.0'
export default KIBERNETES_VERSION
